import React from 'react';
import SubCategoryState from './subCategoryState/SubCategoryState';
import SubCategoryControlPanel from './components/SubCategoryControlPanel/SubCategoryControlPanel';
import SubCategories from './components/SubCategories/SubCategories';
import ModalWindows from './components/ModalWindows/ModalWindows';
import style from './index.module.scss';

const SubCategoryPage: React.FC = () => {
	return (
		<SubCategoryState>
			<div className={style.container} data-test="SubCategoryPage">
				<SubCategoryControlPanel />
				<SubCategories />
				<ModalWindows />
			</div>
		</SubCategoryState>
	);
};

export default SubCategoryPage;
